import controller from './trigger-webhook.controller';

const template = require('./trigger-webhook.html');

export default {
    bindings: {
        action: '<',
        onClose: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/trigger-webhook/trigger-webhook.component.js